import React from 'react';
import TimeRangeSelect, { type TimeRangePreset } from '../../../shared/components/TimeRangeSelect';
import ViewToolbar from '../../../shared/components/ViewToolbar';
import type { EventFilters } from '../../../types/frontend';

const EVENT_PRESETS: TimeRangePreset[] = [
  { value: '15m', label: '15 min' },
  { value: '1h', label: '1 hour' },
  { value: '6h', label: '6 hours' },
  { value: '24h', label: '24 hours' },
];

interface EventExplorerToolbarProps {
  filters: EventFilters;
  setFilters: React.Dispatch<React.SetStateAction<EventFilters>>;
  isAutoRefreshing: boolean;
  isCustomRange: boolean;
  loading: boolean;
  shownCount: number;
  totalCount: number;
  onToggleAutoRefresh: () => void;
  onLoadEvents: () => void;
}

const EventExplorerToolbar: React.FC<EventExplorerToolbarProps> = ({
  filters, setFilters, isAutoRefreshing, isCustomRange, loading, shownCount, totalCount,
  onToggleAutoRefresh, onLoadEvents,
}) => (
  <ViewToolbar
    count={shownCount === totalCount ? `${totalCount} events` : `${shownCount} of ${totalCount}`}
    autoRefresh={{ active: isAutoRefreshing, disabled: isCustomRange, onToggle: onToggleAutoRefresh }}
    onRefresh={onLoadEvents}
    loading={loading}
  >
    <TimeRangeSelect
      presets={EVENT_PRESETS}
      timeRange={filters.timeRange}
      startTime={filters.startTime}
      endTime={filters.endTime}
      onSelectPreset={(value) => {
        if (value === 'custom') {
          setFilters((prev) => ({ ...prev, timeRange: undefined, startTime: '', endTime: '' }));
        } else {
          setFilters((prev) => ({ ...prev, timeRange: value, startTime: undefined, endTime: undefined }));
        }
      }}
      onStartChange={(iso) => setFilters((prev) => ({ ...prev, startTime: iso }))}
      onEndChange={(iso) => setFilters((prev) => ({ ...prev, endTime: iso }))}
      onApply={onLoadEvents}
    />
  </ViewToolbar>
);

export default EventExplorerToolbar;
